import React from "react";
import { CampaignCost } from "../BookingOverview.styled";
import { IconCheck, IconCheckEmpty } from "../../../../../Components/Icons";
import {
  AddButton,
  OptimiseContainer,
  OptimiseText,
  ReviewAmountContainer
} from "../sections/Section.styled";

export const AddonItem = ({ option, freebie = false, handleClick, t }) => {
  return (
    <OptimiseContainer>
      <img src={option.img} alt={option.title} />
      <OptimiseText>
        <h3>{option.title}</h3>
        <p>{option.description}</p>
      </OptimiseText>
      <ReviewAmountContainer>
        {option.check && freebie ? (
          <CampaignCost strike>
            <div>{option.amount}€</div>
            {"0€"}
          </CampaignCost>
        ) : (
          <CampaignCost>{option.amount}€</CampaignCost>
        )}
        <AddButton
          onClick={handleClick}
          disabled={freebie}
          layout
          initial={{ width: "auto", backgroundColor: "transparent" }}
          animate={{ width: "auto", backgroundColor: "transparent" }}
          whileHover={{ backgroundColor: "#1e22ff", color: "rgb(255, 255, 255)" }}
          transition={{
            duration: 0.3,
            ease: "easeInOut"
          }}
          whileTap={{ scale: 1.05 }}
        >
          {option.check ? (
            <>
              {t("Added")} <IconCheck />
            </>
          ) : (
            <>
              {t("Add")} <IconCheckEmpty />
            </>
          )}
        </AddButton>
      </ReviewAmountContainer>
    </OptimiseContainer>
  );
};
